'use strict';

const _ = require('underscore');
const Victor = require('victor');
const d3 = require('d3');

const _transform = _.template('translate(<%= x %>, <%= y %>) scale(<%= scale %>) rotate(<%= rotate %>)');

module.exports = {
    /**
     * SVG の transform attribute を返してくれる
     *
     * @param {Object} d
     * @param {number} d.x
     * @param {number} d.y
     * @param {number} [d.scale=1] - scale parameter
     * @param {number} [d.rotate=0] - rotation angle
     * @returns {String}
     */
    transform: function(d) {
        if(d instanceof Victor) {
            d = d.toObject();
        }
        const scale = d.scale ? d.scale : 1;
        const rotate = d.rotate ? d.rotate : 0;
        const x = d.x;
        const y = d.y;

        return _transform({
            x: x,
            y: y,
            scale: scale,
            rotate: rotate
        })
    },

    getEventPos: function() {
        let pos = d3.mouse(d3.select('svg g g').node());
        if(!pos) {
            pos = d3.touches(d3.select('svg g g').node())[0];
        }
        return {
            x: pos[0],
            y: pos[1]
        };
    },

    getTransform: function(d) {
        const transform = d.attr('transform');
        if(!transform) {
            return {
                x: 0, y: 0, k: 1
            };
        }

        const translate = transform.match(/translate\(([^),]+),([^),]+)\)/);
        const scale = transform.match(/scale\((.*)\)/)[1];
        return {
            x: parseFloat(translate[1]),
            y: parseFloat(translate[2]),
            k: parseFloat(scale)
        };
    }
};



// WEBPACK FOOTER //
// ./common/ui/view/svg/util.js